<template>
  <div class="tooltip-container">
    <div
      class="tooltip-trigger"
      @mouseenter="show"
      @mouseleave="hide"
    >
      <slot name="trigger"></slot>
    </div>
    <div
      v-if="isVisible"
      class="tooltip-content"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'Tooltip',
  setup() {
    const isVisible = ref(false)

    const show = () => {
      isVisible.value = true
    }

    const hide = () => {
      isVisible.value = false
    }

    return {
      isVisible,
      show,
      hide,
    }
  },
})
</script>

<style lang="scss">
.tooltip {
  &-container {
    position: relative;
    display: inline-block;
  }

  &-content {
    position: absolute;
    text-align: left;
    z-index: 10;
    bottom: 100%;
    left: -50%;
    transform: translateX(-50%);
    padding: 0.5rem;
    background-color: white;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-size: 0.75rem;
    max-width: 200px;
    width: max-content;
    overflow-wrap: break-word;
    word-break: break-word;
    margin-bottom: 0.5rem;
  }
}
</style>
